import { gql } from '@apollo/client';

export const PRODUCT_VARIANT_PIM_DATA = gql`
  query getProductVariantPIMData($ids: [ID]!) {
    productVariants(ids: $ids) {
      sku
      components {
        endUse
        endUse2
        primaryMaterial
        lifestyle
      }
    }
  }
`;

export default {};
